export const EMAIL_VALIDATION_PATTERN = /^\S+@\S+$/i;
